module.exports = __webpack_public_path__ + "static/media/pagination-next.2c34bcf0.svg";